import * as queryString from 'querystring';
import type { OAuthProviderType } from '../index';
import getIdpConfig from './getIdpConfig';

export default async function idpResponseHandler(window: Window, parent?: any) {
    if (window.location.search || window.location.hash) {
        const params = queryString.parse(
            window.location.search.substr(1) || window.location.hash.substr(1)
        );

        // QR code for enterprise scenarios: Close window when qrCode is set
        if (params.qrcode) {
            window.close();
        }

        // hellojs encodes the url twice for safari. just decode to redirect to identity provider
        if (params.oauth_redirect) {
            window.location.assign(decodeURIComponent(params.oauth_redirect));
            return;
        }

        const state = JSON.parse(params.state);
        if (state?.callback && parent && state.callback in parent) {
            const providerType: OAuthProviderType = state.network;
            const config = getIdpConfig(providerType, state.client_id)[providerType];
            const scope_delimiter = config.scope_delim || ',';
            const scope = state.scope.split(',').join(scope_delimiter);

            let req = {
                clientId: state.client_id,
                code: params.code,
                providerType: providerType,
                responseType: 'code',
                scope: scope,
                redirectUrl: state.redirect_uri,
                error: undefined,
            };

            if (params.error) {
                req.error = { code: params.error, message: params.error };
            }

            try {
                callback(parent, state.callback)(req);
            } catch (e) {}
        }
    }
    window.close();
}

function callback(parent: Window, callbackID: string) {
    if (callbackID.indexOf('_hellojs_') !== 0) {
        return function () {
            throw new Error('Could not execute callback ' + callbackID);
        };
    }

    return parent[callbackID];
}
